import type { SVGProps } from 'react';

const SvgPlayCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path
      fill={props.color}
      d="M18 36C8.06 36 0 27.94 0 18S8.06 0 18 0s18 8.06 18 18-8.06 18-18 18Zm0-34C9.16 2 2 9.16 2 18s7.16 16 16 16 16-7.16 16-16S26.84 2 18 2Z"
    />
    <path
      fill={props.color}
      d="M18 36C8.07 36 0 27.93 0 18S8.07 0 18 0s18 8.07 18 18-8.07 18-18 18Zm0-33.75C9.32 2.25 2.25 9.32 2.25 18S9.32 33.75 18 33.75 33.75 26.68 33.75 18 26.68 2.25 18 2.25Z"
    />
    <path
      fill={props.color}
      d="M26.72 16.54c1.12.65 1.12 2.27 0 2.92l-11.81 6.82c-1.12.65-2.53-.16-2.53-1.46V11.18c0-1.3 1.41-2.11 2.53-1.46l11.81 6.82Z"
    />
  </svg>
);

export default SvgPlayCircle;
